export default "__VITE_ASSET__BaEb9Op7__"